import { render, staticRenderFns } from "./CButton.vue?vue&type=template&id=58d17ebe&"
import script from "./CButton.vue?vue&type=script&lang=js&"
export * from "./CButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports